<div class="p-4">
  <h2 class="text-2xl font-semibold mb-4">Tableau de bord KPI</h2>

  <app-kpi-filters (filtersChanged)="onFiltersChanged($event)" />

  <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
    <app-kpi-stage-distribution [filters]="filters" />
    <app-kpi-alarm-coverage [filters]="filters" />
    <app-kpi-tolerance-breach [filters]="filters" />
  </div>
</div>
